<template>
    <div class="factory cp" flex="" @click="$router.push({
        name: 'FactoryDetail', 
        query: {
            id: factory.id
        }
    })">
        <div class="vip f0" v-if="factory.is_vip">
            <img src="@/assets/image2/vip.png" />
        </div>
        <div class="page">{{factory.journal_no}}</div>
        <div class="sc f0" @click.stop="toCollect">
            <img v-if="!isCollect" src="@/assets/image2/sc.png" />
            <img v-else src="@/assets/image2/sc-1.png" />
        </div>
        <div class="check" flex="cross:center main:center" v-if="isBatch" @click.stop="">
            <input @change="changeCheck" type="checkbox" v-model="checked" />
        </div>
        <div class="logo f0">
            <img :src="$util.img(factory.cover)" />
        </div>
        <div class="info flex-1">
            <div class="name">{{$lang.getLang() == 'cn' ? factory.name : factory.name_en}}</div>
            <div class="intro">{{emoveHtmlTags($lang.getLang() == 'cn' ? factory.intro : factory.intro_en)}}</div>
            <div class="location" flex="cross:center">
                <div class="icon f0">
                    <img src="@/assets/image2/map.png" />
                </div>
                <div class="text">{{$lang.getLang() == 'cn' ? factory.address : factory.en_address}}</div>
            </div>
            <div class="labels" flex="cross:center">
                <div class="label" v-for="(p, j) in factory.products" :key="j" v-if="j < 3">{{$lang.getLang() == 'cn' ? p.name : p.name_en}}</div>
            </div>
        </div>
        <div class="products" flex="main:right">
            <div class="product" v-for="(p, j) in factory.products" :key="j" v-if="j < 4">
                <div class="image f0">
                    <img v-if="p.images" :src="$util.img(JSON.parse(p.images)[0])" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        factory: {
            type: Object,
            default: null
        },
        collectIds: {
            type: Array,
            default: () => []
        },
        collectPage: {
            type: Boolean,
            default: false
        },
        isBatch: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            checked: false,
            isCollect: false
        }
    },
    mounted(){
        if(this.collectPage){
            this.isCollect = true
        }else{
            this.isCollect = this.collectIds.indexOf(this.factory.id) != -1
        }
    },
    methods: {
        async toCollect(){
            let index = this.$layer.loading()
            let res = await this.$api.rApi('user/collect-factory', {
                factory_id: this.factory.id,
                type: this.isCollect ? 2 : 1,
                lang: this.$lang.getLang()
            })
            this.$layer.close(index)
            if(res.status == 1){
                if(this.collectPage){
                    this.$emit('refresh')
                }else{
                    this.isCollect = !this.isCollect
                }
            }else{
                this.$layer.msg(res.msg)
            }
        },
        changeCheck(e){
            this.$emit('change', this.factory.id, this.checked)
        },
        emoveHtmlTags(text) {
            text = text.replace(/&nbsp;/g, ' ')
            return text.replace(/<[^>]*>/g, '');
        },
    }
}
</script>

<style lang="scss" scoped>

    .factory{
        padding-left: 52px;
        padding-top: 40px;
        position: relative;
        width: 1240px;
        height: 214px;
        background: #FFFFFF;
        box-shadow: 0px 10px 20px 1px rgba(0,0,0,0.05);
        border-radius: 10px 10px 10px 10px;
        margin-bottom: 16px;
        box-sizing: border-box;
        .vip{
            position: absolute;
            left: 0;
            top: 0;
            img{
                width: 67px;
                height: 29px;
            }
        }
        .page{
            font-family: Arial, Arial;
            font-weight: 400;
            font-size: 14px;
            color: #216347;
            position: absolute;
            left: 19px;
            bottom: 17px;
        }
        .sc{
            position: absolute;
            top: 26px;
            right: 39px;
            img{
                width: 17.62px;
                height: 17.62px;
            }
        }
        .logo{
            img{
                width: 180px;
                height: 135px;
            }
        }
        .check{
            padding-bottom: 40px;
            margin-right: 20px;
            cursor: pointer;
        }
        .info{
            width: 447px;
            padding-left: 16px;
            .name{
                height: 22px;
                font-family: Arial, Arial;
                font-weight: bold;
                font-size: 20px;
                color: #000000;
                line-height: 22px;
                margin-bottom: 12px;
                white-space: normal;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .intro{
                width: 447px;
                height: 32px;
                font-family: Arial, Arial;
                font-weight: 400;
                font-size: 14px;
                color: #000000;
                line-height: 16px;
                margin-bottom: 12px;
            }
            .location{
                margin-bottom: 17px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                .icon{
                    img{
                        width: 12.72px;
                        height: 15.9px;
                    }
                }
                .text{
                    font-family: Arial, Arial;
                    font-weight: 400;
                    font-size: 14px;
                    color: #216347;
                    margin-left: 6px;
                    max-width: 440px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
            .labels{
                .label{
                    padding: 0 10px;
                    height: 24px;
                    border-radius: 50px 50px 50px 50px;
                    border: 1px solid #216347;
                    font-family: Arial, Arial;
                    font-weight: 400;
                    font-size: 12px;
                    color: #216347;
                    line-height: 24px;
                    margin-right: 10px;
                }
            }
        }
        .products{
            margin-top: 26px;
            margin-right: 50px;
            .product{
                width: 110px;
                height: 110px;
                margin-right: 6px;
                overflow: hidden;
                border: 1px solid #E9E9E9;
                img{
                    transition: .3s;
                    width: 110px;
                    height: 110px;
                    box-sizing: border-box;
                    &:hover{
                        transition: .3s;
                        width: 120px;
                        height: 120px;
                        margin-top: -5px;
                        margin-left: -5px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Factory.vue